import React, { Fragment, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import pt from 'date-fns/locale/pt';
import { Card, CardBody } from 'reactstrap';
import Panel from '../../../shared/components/Panel';
import StudentActiveChart from './StudentActiveChart';
import StudentsDistributionChart from './StudentsDistributionChart';
import {
  schoolStudentQuantity,
  dashboardClassOccupationData,
} from '../../../shared/queries/Dashboard';

import GraphQL from '../../../GraphQL';

const OccupationBoard = (props) => {
  const [activeStudentQuantity, setActiveStudentQuantity] = useState([]);
  const [months, setMonths] = useState([]);
  const [contectedPlan, setContectedPlan] = useState([]);
  const [classesNames, setClassesNames] = useState([]);
  const [occupation, setOccupation] = useState([]);
  const [capacity, setCapacity] = useState([]);

  const { t } = props;

  const options = {
    responsive: true,
    maintainAspectRatio: false,
  };

  const loadStudentQuantityData = () => {
    const query = schoolStudentQuantity();
    GraphQL(query, {})
      .then((res) => {
        const mappedMonth = res.schoolStudentQuantity.map((item) =>
          format(new Date(item.dateInMilli), 'MMM', { locale: pt })
        );
        setMonths(mappedMonth);
        const mappedActiveStudentQuantity = res.schoolStudentQuantity.map(
          (item) => item.activeStudentQuantity
        );
        setActiveStudentQuantity(mappedActiveStudentQuantity);

        const mappedcontractedPlan = res.schoolStudentQuantity.map(
          (item) => item.contractedStudentQuantity
        );

        setContectedPlan(mappedcontractedPlan);
      })
      .catch(() => {});
  };

  const loadClassOccupationData = () => {
    const query = dashboardClassOccupationData();
    GraphQL(query, {})
      .then((res) => {
        if (res.dashBoardClassOccupationData) {
          const mappedClasses = res.dashBoardClassOccupationData.map(
            (item) => item.className
          );
          setClassesNames(mappedClasses);

          const mappedOccupation = res.dashBoardClassOccupationData.map(
            (item) => item.occupation
          );
          setOccupation(mappedOccupation);

          const mappedCapacity = res.dashBoardClassOccupationData.map(
            (item) => item.capacity
          );
          setCapacity(mappedCapacity);
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    loadStudentQuantityData();
    loadClassOccupationData();
  }, []);

  return (
    <Fragment>
      <h2 className="dashboard-titles">
        {t('dashboard.occupationBoard.title')}
      </h2>
      <Card>
        <CardBody className="card-student-actives">
          <Panel
            title={t(
              'dashboard.occupationBoard.charts.studentsDistribution.title'
            )}
          >
            <Card className="pt-0 occupation-charts">
              <StudentsDistributionChart
                classesNames={classesNames}
                occupation={occupation}
                capacity={capacity}
              />
            </Card>
          </Panel>
        </CardBody>
      </Card>
      <Card>
        <CardBody className="card-student-actives">
          <Panel
            title={t('dashboard.occupationBoard.charts.studentActives.title')}
          >
            <Card className="pt-0 occupation-charts">
              <StudentActiveChart
                months={months}
                activeStudentQuantity={activeStudentQuantity}
                contectedPlan={contectedPlan}
                options={options}
              />
            </Card>
          </Panel>
        </CardBody>
      </Card>
    </Fragment>
  );
};

OccupationBoard.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(OccupationBoard);
